module.exports = __webpack_public_path__ + "img/card-bg.37e4ba31.png";